import { CHAINS, RPC_MAP, SUPPORTED_CHAINS } from 'consts';
import { Chain, HttpTransport } from 'viem';
import { createConfig, http } from 'wagmi';

import { connectors } from './connectors';

const chains = Object.values(CHAINS);

const transports: Record<number, HttpTransport> = {};

chains.forEach((chain) => {
  transports[chain.id] = http(SUPPORTED_CHAINS.includes(chain.id) ? RPC_MAP[chain.id] : undefined);
});

export const web3Config = createConfig({
  chains: chains as [Chain, ...Chain[]],
  connectors,
  transports,
});
